import { roundToPrecision } from 'helpers/calculateToPrecision';
import { ExchangeDetails } from 'pages/cryptoV2/models';
import { QuantityType, ReviewedDetails } from '../CryptoExchangeModal';
import { formatGeneralCurrency } from './FromTo';
import { useTranslation } from 'react-i18next';

export const OrderSummary = ({
    orderDetails,
    exchangeDetails,
}: {
    orderDetails: ReviewedDetails;
    exchangeDetails: ExchangeDetails;
}) => {
    const { t } = useTranslation('crypto');
    const reverseUx = orderDetails.assetPairSwapped;
    const isBuyExchange = orderDetails.exchangeType === 'Buy';

    const isExactBuy = orderDetails.quantityType === QuantityType.Destination;
    const isExactSell = orderDetails.quantityType === QuantityType.Source;
    const buyingStr = isExactBuy ? t('youreBuyingExactly') : t('youreBuying');
    const sellingStr = isExactSell ? t('youreSellingExactly') : t('youreSelling');
    const firstString = isBuyExchange ? buyingStr : sellingStr;
    const secondString = isBuyExchange ? sellingStr : buyingStr;

    const fromAccount = exchangeDetails.fromAccounts.find(
        (acc) => acc.accountID == orderDetails.sourceAccountId
    );
    const toAccount = exchangeDetails.mergedToAccounts.find(
        (acc) =>
            (acc.accountID !== null && acc.accountID == orderDetails.destinationAccountId) ||
            (acc.payeesId !== null && acc.payeesId == orderDetails.destinationPayeeId)
    );

    return (
        <div>
            <div
                className="BuySellAmounts"
                style={{ flexDirection: reverseUx ? 'row-reverse' : 'row' }}
            >
                <div>
                    <h4>{firstString}</h4>
                    <h3 className="notranslate" translate="no">{formatGeneralCurrency(orderDetails.amount, orderDetails.asset)}</h3>
                </div>
                <div>
                    <h4>{secondString}</h4>
                    <h3 className="notranslate" translate="no">
                        {formatGeneralCurrency(orderDetails.totalPrice, orderDetails.pairedAsset)}
                    </h3>
                    <span>
                        ({orderDetails.price}{' '}
                        {isBuyExchange
                            ? reverseUx
                                ? t('afterFees')
                                : t('plusFees')
                            : reverseUx
                            ? t('beforeFees')
                            : t('minusFees')}{' '}
                        {t('fees')})
                    </span>
                </div>
            </div>
            <div className="ExchangeRate ExchangeRateConfirm">
                <div>{t('quotedPrice')}</div>
                <div className="Rates notranslate" translate="no">
                    <p>
                        {exchangeDetails.asset} 1 <span className="c1">{'>'}</span>
                        <span className="c2">{'>'}</span>
                        <span className="c3">{'>'}</span> {exchangeDetails.pairedAsset} ~
                        {roundToPrecision(
                            isBuyExchange ? 1 / orderDetails.buyPrice : 1 / orderDetails.sellPrice,
                            8
                        )}
                    </p>
                    <p>
                        {exchangeDetails.pairedAsset} 1 <span className="c1">{'>'}</span>
                        <span className="c2">{'>'}</span>
                        <span className="c3">{'>'}</span> {exchangeDetails.asset} ~{' '}
                        {roundToPrecision(
                            !isBuyExchange ? orderDetails.sellPrice : orderDetails.buyPrice,
                            8
                        )}
                    </p>
                </div>
            </div>
            <div className="SummaryRow">
                <div className="RowInfo">
                    <p>{t('from')}</p>
                    <h4>
                        <span className="notranslate" translate="no">
                            {fromAccount?.displayName}
                        </span>
                    </h4>
                </div>
                <div className="RowInfo">
                    <p>{t('to')}</p>
                    <h4>
                        <span className="notranslate" translate="no">
                            {toAccount?.label}
                        </span>
                    </h4>
                </div>
            </div>
            <div className="SummaryRow">
                <div className="RowInfo">
                    <p>{t('myComment')}</p>
                    <h4>
                        <span className="notranslate" translate="no">
                            {orderDetails.comment ? orderDetails.comment : '--'}
                        </span>
                    </h4>
                </div>
            </div>
        </div>
    );
};
